"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorageFactory = void 0;
function localStorageFactory(key, options = { isObject: true }) {
    const lsKey = `@w-flow/${key}`;
    const { isObject } = options;
    if (typeof localStorage === 'undefined')
        throw new Error('Unsupported platform');
    return {
        get() {
            const val = localStorage.getItem(lsKey);
            if (isObject) {
                try {
                    return val ? JSON.parse(val) : null;
                }
                catch (error) {
                    console.error(error);
                    return null;
                }
            }
            else {
                return val;
            }
        },
        set(value) {
            try {
                const val = isObject ? JSON.stringify(value) : String(value);
                localStorage.setItem(lsKey, val);
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        },
        assign(value) {
            if (!isObject) {
                throw new Error('type error');
            }
            const old = this.get();
            if (!old) {
                this.set(value);
            }
            const val = { ...old, ...value };
            this.set(val);
        },
    };
}
exports.localStorageFactory = localStorageFactory;
//# sourceMappingURL=localStorageFactory.js.map